import { render } from "./HiddenSetingsOverlay.vue?vue&type=template&id=1e89a294"
import script from "./HiddenSetingsOverlay.vue?vue&type=script&lang=js"
export * from "./HiddenSetingsOverlay.vue?vue&type=script&lang=js"

import "./HiddenSetingsOverlay.vue?vue&type=style&index=0&id=1e89a294&lang=scss"
script.render = render

export default script